import { PsOriginBase } from './PsOriginBase';

export class PsWork extends PsOriginBase {

    _id; // number
    _name; // string

    constructor(
        id,
        name,
    ) {
        super();
        this._id = id;
        this._name = name;
    }

    static fromAPIWork(work) {
        return new this(
            work.id,
            work.name || '',
        );
    }

    id() {
        return this._id;
    }

    name() {
        return this._name;
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/shared/model/PsWork.js